// Celebrity personas
export const PERSONAS = [
    {
        id: 'EANDREEVA',
        name: 'Екатерина Андреева',
        image: '/celebratory/Екатерина Андреева.jpg',
        video: 'https://storage.yandexcloud.net/selebrus-page-assets/Main/andreeva.mp4'
    },
    {
        id: 'PUTIN_BEREZKI',
        name: 'Владимир Путин',
        image: '/celebratory/Владимир Путин.jpg',
        video: 'https://storage.yandexcloud.net/selebrus-page-assets/Main/putin.mp4'
    },
    {
        id: 'BURUNOV_FIREPLACE',
        name: 'Сергей Бурунов',
        image: '/celebratory/sergei-burunov.jpg',
        video: 'https://storage.yandexcloud.net/selebrus-page-assets/Main/burunov.mp4'
    },
    {
        id: 'URGANT',
        name: 'Иван Ургант',
        image: '/celebratory/Иван Ургант.jpg',
        video: 'https://storage.yandexcloud.net/selebrus-page-assets/Main/urgant.mp4'
    },
    {
        id: 'MALAHOV',
        name: 'Андрей Малахов',
        image: './celebratory/andrei-malahov.jpg',
        video: 'https://storage.yandexcloud.net/selebrus-page-assets/Main/malahov.mp4'
    },
    {
        id: 'KIRKOROV',
        name: 'Филипп Киркоров',
        image: '/celebratory/Фил Киркоров.jpg',
        video: 'https://storage.yandexcloud.net/selebrus-page-assets/Main/kirkorov.mp4'
    },
    {
        id: 'DMITRIENKO',
        name: 'Ваня Дмитриенко',
        image: '/celebratory/Ваня Дмитриенко.jpg',
        video: 'https://storage.yandexcloud.net/selebrus-page-assets/Main/dmitrienko.mp4'
    },
    {
        id: 'HARLAMOV',
        name: 'Гарик Харламов',
        image: '/celebratory/Гарик Харламов.jpg',
        video: 'https://storage.yandexcloud.net/selebrus-page-assets/Main/harlamov.mp4'
    },
    {
        id: 'TRUMP',
        name: 'Дональд Трамп',
        image: '/celebratory/Дональд Трамп.jpg',
        video: 'https://storage.yandexcloud.net/selebrus-page-assets/Main/trump.mp4'
    },
    {
        id: 'ELON',
        name: 'Илон Маск',
        image: '/celebratory/Илон праздник Маск.jpg',
        video: 'https://storage.yandexcloud.net/selebrus-page-assets/Main/elon.mp4'
    },
];

export function getPersonaById(id) {
    return PERSONAS.find(p => p.id === id);
}

export function getOrderedPersonas(preSelectedId) {
    if (!preSelectedId) return PERSONAS;
    const selected = PERSONAS.find(p => p.id === preSelectedId);
    if (!selected) return PERSONAS;
    return [selected, ...PERSONAS.filter(p => p.id !== preSelectedId)];
}
